/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approval_Not_Set_LabelInputs */



/**
* | output |
* | --- |
* | "Approval Not Set" |
*
* @param {Style_Guide_Manager_Approval_Not_Set_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approval_not_set_label = /** @type {((inputs?: Style_Guide_Manager_Approval_Not_Set_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approval_Not_Set_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approbation non definie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigung nicht festgelegt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvazione non impostata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Утверждение не установлено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobación no establecida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审批未设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認が設定されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमोदन अभी तक निर्धारित नहीं किया गया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovação não definida")
	return /** @type {LocalizedString} */ ("Approval Not Set")
});